import React, { useState, useEffect, useMemo } from 'react';
import { Segment } from 'tea-component';
import CountryTable from './Table';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import Visualis from './Visualis';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { IconFourList } from '@intelligence/components/CardSlotV2';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import { getCountriesCardTitleI18nKey } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_config/countriesCardTitle';
import { getMobileCountriesChartName } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_utils/countryName';

const CountriesCard = (props: any) => {
  const {
    loading,
    tableData = [],
    unPublishedAppIdList = [],
    pageId,
    dataSource,
    entityType,
    gameName,
    gameCover,
    dateType,
    startDate,
    endDate,
    chartType,
    setChartType,
    changeSegement,
    lineData,
    metric,
    marketChartList,
    chartSegment,
    cardStatus,
    isDropdown,
    fixedTableData,
    marketType,
    regionsCountries,
    getRpdTypeData,
    chartLoading,
    setChartLoading,
    setChartLineLoading,
    chartLineLoading,
    baseReleaseTime,
    earliestPeriod,
    earliestDay,
    pageSortAttr,
    onTableSortChage,
    countriesType: regionSegVal,
    firstWeekSinceReleaseDates,
  } = props;

  // console.log('CountriesCard', props);

  const { locale, formatMessage } = useIntlExtend(); // 中英切换方法
  const localizedOthersName = formatMessage({ id: 'dbi_others' });
  const { isLoading, isError, isNoData } = cardStatus || {};
  // const [regionSegVal, setRegionSegVal] = useState(countriesType);
  // const [metricSegVal, setMetricSegVal] = useState('D2');
  const [barSeries, setBarSeries] = useState<any>([]);
  const [pieSeries, setPieSeries] = useState<any>([]);

  useEffect(() => {
    const barSeries: any[] = [];
    const pieSeries: any[] = [];
    let isNull = true;
    const marketChartListTmp = Array.isArray(marketChartList) ? marketChartList : [];

    marketChartListTmp?.forEach((item: any) => {
      const metrics = Array.isArray(item?.metrics) ? item.metrics : [];
      const metricsData = metrics.find((metricItem: any) => metricItem.metric == chartSegment) || {};
      const valueTemp = metricsData?.value || 0;
      if (valueTemp) {
        isNull = false;
      }

      barSeries.push({
        app_id: item?.market || '',
        // name: getCountryNameByCountryCode(regionsCountries, item?.market, regionSegVal) || '',  //需要转变成国家全称
        name: item?.market,
        cover: item?.market || '',
        value: valueTemp,
      });

      pieSeries.push({
        app_id: item?.market || '',
        name: getMobileCountriesChartName({
          regionsCountries,
          countryCode: item?.market,
          regionSegVal,
          fallbackName: item?.name,
          localizedOthersName,
        }),
        cover: item?.market || '',
        value: valueTemp,
      });
    });

    setBarSeries(isNull ? [] : barSeries);
    setPieSeries(isNull ? [] : pieSeries);
  }, [marketChartList, regionsCountries, regionSegVal, chartSegment, localizedOthersName, locale]);

  const countriesSharTitle = useMemo(() => {
    const titleI18nKey = getCountriesCardTitleI18nKey({
      dimension: regionSegVal,
      metric: pageId,
      chartType,
    });

    return formatMessage({ id: titleI18nKey });
  }, [regionSegVal, pageId, chartType, formatMessage]);

  const trendTitle = useMemo(() => {
    switch (pageId) {
      case 'activeusers':
        return 'dbi_active_users';
      case 'revenue':
        return 'dbi_revenue';
      case 'downloads':
        return 'dbi_downloads';
      default:
        return ''
    }
  }, [pageId])

  if (isLoading || isNoData || isError || isDropdown) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={countriesSharTitle}
        iconList={[]}
      >
        <CardStats cardStatus={cardStatus} isDropdown={isDropdown} />
      </CardSlotV2>
    );
  }

  return (
    <div className="dbi-countries-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={countriesSharTitle}
        // rightText={earliestLoading ? '' : `${formatMessage({ id: `dbi_detail_earliest_date` })}: ${earliestDay}`}
        // rightTip={formatMessage({ id: `dbi_detail_earlistdate_info` })}
        rightText={earliestDay ? `${formatMessage({ id: `dbi_detail_earliest_date` })}: ${earliestDay}` : ''}
        rightTip={earliestDay ? formatMessage({ id: `dbi_detail_earlistdate_info` }) : ''}
        activeTab={chartType}
        iconList={IconFourList}
        getChange={(value: any) => {
          setChartType(value);
        }}
      >
        <div className="retention-segment">
          <Segment
            className="segment-right"
            value={regionSegVal}
            onChange={(value) => {
              // setRegionSegVal(value);
              changeSegement(value);
            }}
            options={[
              { text: formatMessage({ id: 'dbi_game_detail_countries' }), value: 'market' },
              { text: formatMessage({ id: 'dbi_game_detail_region' }), value: 'region' },
            ]}
          />
        </div>
        <div className="trends-card-line">
          <Visualis
            lineData={lineData}
            metric={metric}
            imageType={entityType}
            chartType={chartType}
            pieSeries={pieSeries}
            barSeries={barSeries}
            middleTitle={gameName}
            dataSource={dataSource}
            regionsCountries={regionsCountries}
            regionSegVal={regionSegVal}
            setChartLoading={setChartLoading}
            chartLoading={chartLoading}
            setChartLineLoading={setChartLineLoading}
            chartLineLoading={chartLineLoading}
            dateType={dateType}
            startDate={startDate}
            endDate={endDate}
            getRpdTypeData={getRpdTypeData}
            isNoData={isNoData}
            baseReleaseTime={baseReleaseTime}
            earliestPeriod={earliestPeriod}
            pageId={pageId}
            isStackLine={chartType === ChartType.StackedLine}
            secondTitleRight={formatMessage({ id: trendTitle })}
            firstWeekSinceReleaseDates={firstWeekSinceReleaseDates}
          />
        </div>
        <CountryTable
          loading={loading}
          entityType={entityType}
          gameName={gameName}
          gameCover={gameCover}
          chartSegment={chartSegment}
          tableData={tableData}
          pageId={pageId}
          dataSource={dataSource}
          unPublishedAppIdList={unPublishedAppIdList}
          dateType={dateType}
          startDate={startDate}
          endDate={endDate}
          regionsCountries={regionsCountries}
          fixedTableData={fixedTableData}
          marketType={marketType}
          regionSegVal={regionSegVal}
          pageSortAttr={pageSortAttr}
          onTableSortChage={onTableSortChage}
        />
      </CardSlotV2>
    </div>
  );
};

export default CountriesCard;
